/**
 * Hash
 * Use this for hashing keys
 */

/* eslint no-bitwise: [2, { allow: ["<<", "|="] }] */
// eslint-disable-next-line import/prefer-default-export
export const Hash = (s: string) => {
  let hash = 0
  let i
  let chr

  if (!s || s.length === 0) return hash

  for (i = 0; i < s.length; i += 1) {
    chr = s.charCodeAt(i)
    hash = (hash << 5) - hash + chr
    hash |= 0
  }

  return hash
}
